export interface TriggerCondition {
  fieldName: string;
  operator: string;
  value?: string;
  customField?: boolean;
}

export interface OrgTrigger {
  id?: string; // UUID
  entity: string;
  // Legacy (una sola condicion). Los triggers nuevos usan conditions[].
  field_name?: string;
  condition_type?: string;
  condition_value?: string;
  // Multi-condicion (AND).
  conditions?: TriggerCondition[];
  // 'on_change' (reactivo) | 'scheduled' (barrido diario).
  run_mode?: string;
  // Valores del enum contact_type a los que aplica (vacio = todos).
  contact_types?: string[];
  action_type: string;
  action_config: Record<string, any>; // JSON object
  enabled?: boolean;
  organization_id: string; // UUID
  created_at?: string;
  updated_at?: string;
  created_by?: string; // UUID
  updated_by?: string; // UUID
}

export interface TriggerFilter {
  page: number;
  rowsPerPage: number;
  entity?: string;
  field?: string;
  enabled?: boolean;
  search?: string;
}

export interface TriggerResponse {
  data: OrgTrigger[];
  total: number;
  page: number;
  rowsPerPage: number;
}

export const CONDITION_TYPES = [
  { value: 'any', label: 'Any' },
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Not Equals' },
  { value: 'changed_from', label: 'Changed From' },
  { value: 'changed_to', label: 'Changed To' },
];

// Operadores de estado para conditions[] (misma semantica que Dynamic Views).
export const TRIGGER_OPERATORS = [
  { value: '=', label: 'Equals' },
  { value: '<>', label: 'Not Equals' },
  { value: '>', label: 'Greater Than' },
  { value: '<', label: 'Less Than' },
  { value: '>=', label: 'Greater or Equal' },
  { value: '<=', label: 'Less or Equal' },
  { value: 'IS NULL', label: 'Is Empty' },
  { value: 'IS NOT NULL', label: 'Is Not Empty' },
];

// Operadores sin valor a la derecha.
export const OPERATORS_WITHOUT_VALUE = ['IS NULL', 'IS NOT NULL'];

export const TRIGGER_RUN_MODES = [
  { value: 'on_change', label: 'On change (reactive)' },
  { value: 'scheduled', label: 'Scheduled (daily sweep)' },
];

export const ACTION_TYPES = [
  { value: 'update_fields', label: 'Update Fields' },
  { value: 'archive_record', label: 'Archive Record' },
];

export const ENTITY_TYPES = [
  { value: 'contacts', label: 'Contacts' },
  { value: 'prospects', label: 'Prospects' },
  { value: 'leads', label: 'Leads' },
  { value: 'opportunities', label: 'Opportunities' },
  { value: 'accounts', label: 'Accounts' },
  { value: 'tasks', label: 'Tasks' },
  { value: 'notes', label: 'Notes' },
];
